/* Juvetti ring size helper: shopper must pick a ring size; "Other size" needs the size typed in. */
(function () {
  if (window.__juvRingSize) return;
  window.__juvRingSize = true;

  var chosen = {};
  var otherVals = {};
  var PROPS = ['border-color', 'background-color', 'color', 'box-shadow', 'outline-color'];

  function fieldsets() { return document.querySelectorAll('fieldset[data-ring-size]'); }
  function fid(fs) { return fs.getAttribute('data-form-id'); }
  function fsFor(id) { return document.querySelector('fieldset[data-ring-size][data-form-id="' + id + '"]'); }
  function checked(fs) { return fs.querySelector('input[type="radio"]:checked'); }
  function labelOf(i) { return i && i.labels && i.labels[0] ? i.labels[0] : null; }
  function isOther(fs) { var l = labelOf(checked(fs)); return !!(l && /other size/i.test(l.textContent)); }
  function otherInput(fs) { return fs.querySelector('[data-ring-other] input'); }

  function neutralise(fs) {
    var lab = labelOf(checked(fs));
    if (!lab || lab.hasAttribute('data-ring-neutral')) return;
    var ref = null;
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) {
      var l = labelOf(i);
      if (!ref && !i.checked && l && !l.classList.contains('is-disabled')) ref = l;
    });
    if (!ref) return;
    var cs = getComputedStyle(ref);
    PROPS.forEach(function (p) { lab.style.setProperty(p, cs.getPropertyValue(p), 'important'); });
    lab.setAttribute('data-ring-neutral', '');
  }

  function clearNeutral(fs) {
    fs.querySelectorAll('[data-ring-neutral]').forEach(function (l) {
      PROPS.forEach(function (p) { l.style.removeProperty(p); });
      l.removeAttribute('data-ring-neutral');
    });
  }

  function problem(id) {
    var fs = fsFor(id);
    if (!fs) return null;
    if (!chosen[id]) return { fs: fs, msg: 'Please select a size.' };
    if (isOther(fs)) {
      var inp = otherInput(fs);
      if (!inp || !inp.value.trim()) return { fs: fs, msg: 'Please enter your ring size.', focus: inp };
    }
    return null;
  }

  function apply() {
    fieldsets().forEach(function (fs) {
      var id = fid(fs);
      var prompt = fs.querySelector('[data-ring-size-prompt]');
      if (!chosen[id]) { neutralise(fs); if (prompt) prompt.hidden = false; }
      else { clearNeutral(fs); if (prompt) prompt.hidden = true; }

      var box = fs.querySelector('[data-ring-other]');
      var inp = otherInput(fs);
      var show = !!chosen[id] && isOther(fs);
      if (box) box.hidden = !show;
      if (inp) {
        inp.disabled = !show;
        if (show && otherVals[id] && !inp.value) inp.value = otherVals[id];
      }

      var form = document.getElementById(id);
      var pb = form && form.querySelector('.shopify-payment-button');
      if (pb) pb.classList.toggle('ring-size-hold', !!problem(id));
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }

  function hideErr(fs) { var e = fs && fs.querySelector('[data-ring-error]'); if (e) e.hidden = true; }

  function stop(e, p) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var err = p.fs.querySelector('[data-ring-error]');
    if (err) { err.textContent = p.msg; err.hidden = false; }
    p.fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (p.focus) setTimeout(function () { p.focus.focus({ preventScroll: true }); }, 300);
  }

  function markChosen(t) {
    var fs = t.closest && t.closest('fieldset[data-ring-size]');
    if (!fs) return;
    chosen[fid(fs)] = true;
    hideErr(fs);
    schedule();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('fieldset[data-ring-size] .variant-picker__option-values')) { markChosen(t); return; }

    var hold = t.closest('.ring-size-hold');
    var btn = hold || t.closest('button[type="submit"]');
    if (!btn) return;
    var form = btn.closest('form') || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form')));
    var formId = form && form.getAttribute('id');
    if (!formId) return;
    var p = problem(formId);
    if (p) stop(e, p);
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.type === 'radio') markChosen(e.target);
  }, true);

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-ring-other]');
    if (!box) return;
    var fs = box.closest('fieldset[data-ring-size]');
    otherVals[fid(fs)] = e.target.value;
    hideErr(fs);
    schedule();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var formId = f && f.getAttribute && f.getAttribute('id');
    if (!formId) return;
    var p = problem(formId);
    if (p) stop(e, p);
  }, true);

  function start() {
    var style = document.createElement('style');
    style.textContent = '.ring-size-hold{opacity:.5;cursor:pointer}.ring-size-hold>*{pointer-events:none}.ring-size-error{color:#b3261e}';
    document.head.appendChild(style);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    apply();
    window.addEventListener('load', function () {
      fieldsets().forEach(function (fs) { if (!chosen[fid(fs)]) clearNeutral(fs); });
      apply();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
